/**
 * Generated by orval 🍺
 * Do not edit manually.
 * CliniShift Manager
 * The CliniShift Manager API is used to manage the CliniShift platform. This API is used by the CliniShift Manager Portal.
 * OpenAPI spec version: 1.0
 */
import * as zod from 'zod';

export const Meta = zod.object({
  "pagination": zod.object({
  "total": zod.int(),
  "count": zod.int(),
  "per_page": zod.int(),
  "current_page": zod.int(),
  "total_pages": zod.int()
}).optional()
}).describe('Meta model');

export type Meta = zod.input<typeof Meta>;
export type MetaOutput = zod.output<typeof Meta>;
